import { Box, Button, Grid, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router';
import { CommonLayout } from '../commonComponents';
import { useDispatch, useSelector } from 'react-redux';
import { USER_ROLES } from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import DoughnutGraph from './doughnutGraph';
import MonthOnMonthAndOnboardingStatus from './monthOnMonthAndStatus';
import TopDistributorRM from './topDistributorsRM';
import CommitmentAndContribution from './commitmentAndContribution';
import DashboardAndApplicationsList from './applicationslist';
import { useEffect, useState } from 'react';
import { ApplicationProps, OnboardingFilterType, RMType } from '../../redux-store/types/api-types';
import { getAllApplications } from '../../redux-store/actions/application';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import OnboardingDashboard from './OnboardingDashboard';
import {
  Distributor,
  getDistributors,
  getDistributorsListForFilters,
  getDistributorsResponse,
} from '../../redux-store/actions';
import { FundProps, GetFundsListResponseBody } from '../../redux-store/types/funds';
import { getFunds, getFundsList } from '../../redux-store/actions/funds';

export default function Dashboard(): JSX.Element {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [funds, setFunds] = useState<FundProps[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      let response = [] as unknown as FundProps[];
      if ([USER_ROLES.RM].includes(role)) {
        response = (await dispatch(
          getFunds({
            isActive: true,
            isApplicableForDirect: true,
          })
        )) as unknown as FundProps[];
      } else if ([USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role)) {
        response = (await dispatch(
          getFunds({
            isActive: true,
            isApplicableForDistributor: true,
          })
        )) as unknown as FundProps[];
      } else {
        response = ((await dispatch(getFundsList())) as unknown as GetFundsListResponseBody)?.funds;
      }

      setFunds(response || []);

      let distributors = [] as Distributor[];
      if ([USER_ROLES.AMC_ADMIN, USER_ROLES.SUPER_ADMIN].includes(role)) {
        distributors = (await dispatch(
          getDistributorsListForFilters()
        )) as unknown as Distributor[];
      } else if ([USER_ROLES.RM].includes(role)) {
        distributors = (
          (await dispatch(
            getDistributors({ isActive: true })
          )) as unknown as getDistributorsResponse
        )?.distributors;
      }

      setDistributors(distributors || []);
    })();
  }, []);

  useEffect(() => {
    let componentIsAlive = true;
    setLoading(true);
    setApplicationsList([]);
    (async function () {
      try {
        const response = (await dispatch(
          getAllApplications({
            page: 1,
            limit: 4,
          })
        )) as unknown as GetAllApplicantionsResponseBody;
        const { applications } = response || {};
        setLoading(false);
        if (!componentIsAlive) {
          return;
        }
        setApplicationsList(applications);
      } catch (e) {
        setLoading(false);
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, []);

  return (
    <CommonLayout>
      <>
        <Grid container spacing={4} py={2}>
          {/* {' '} */}
          <OnboardingDashboard funds={funds} distributors={distributors} />
        </Grid>
        <Grid container spacing={4}>
          <DoughnutGraph />
          <MonthOnMonthAndOnboardingStatus />
        </Grid>
        <Grid container spacing={4} py={4}>
          {USER_ROLES.AMC_ADMIN === role && <TopDistributorRM />}
          <CommitmentAndContribution />
        </Grid>
        <Box>
          <Box
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Recent Applications
            </Typography>
            {[USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role) && (
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  mr: { xs: 1, sm: 2.5 },
                  p: 1,
                }}
                onClick={() => history.push('/onboarding')}>
                Add Applicant
              </Button>
            )}
          </Box>
          <Box mt={3} sx={{ maxWidth: { lg: '100%' } }}>
            <DashboardAndApplicationsList
              isLoading={isLoading}
              applicationsList={applicationsList}
              boxStyles={{ minHeight: '350px', minWidth: 450 }}
              DashboardApplicationsList={true}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 5 }}>
            {/* <IconButton to={{ pathname: '/applications' }} component={RouterLink}> */}
            <Button
              variant="contained"
              sx={{
                maxWidth: 20,
                maxHeight: 30,
                minWidth: 200,
                minHeight: 40,
              }}
              onClick={() => history.push('/applications')}>
              View More
            </Button>
            {/* </IconButton> */}
          </Box>
        </Box>
      </>
    </CommonLayout>
  );
}
